/* eslint-disable no-undef */
/* eslint-disable func-names */
/* eslint linebreak-style: ["error", "windows"] */
/**
 * Sticky Header
 * @param   {object/string} opts
 * @return  {object/string}
 */
export default function () {
  const header = $('.header--site');

  const onScroll = () => {
    if (!header) return;
    if ($(window).scrollTop() > 1) {
      header.addClass('header--sticky');
    } else {
      header.removeClass('header--sticky');
    }
  };

  const adjustPadding = () => {
    $('.site-container').css('padding-top', header.outerHeight());
  };

  const onResize = () => {
    onScroll();
    adjustPadding();
  };

  window.addEventListener('load', adjustPadding());
  window.addEventListener('scroll', am2.fn.debounce(onScroll, 10));
  window.addEventListener('resize', am2.fn.debounce(onResize, 150));
}
